import { render, staticRenderFns } from "./TabText.vue?vue&type=template&id=0904bbfe&scoped=true&"
import script from "./TabText.vue?vue&type=script&lang=js&"
export * from "./TabText.vue?vue&type=script&lang=js&"
import style0 from "./TabText.vue?vue&type=style&index=0&id=0904bbfe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0904bbfe",
  null
  
)

export default component.exports